// Import/export dicom metadata dictionary

import metadata from "./app/library/dicom/metadata";
export default metadata;
